import $ from 'jquery';
import _ from 'lodash';
import { saveEditorCanvas } from '~src/api';
import { onErrorShowMessage } from '~src/errors';
import {
  calculateFormat,
  toggleEditorHomeMenu,
  showSpinner,
} from '~loader/loader-utils';
import { router } from '~src/router';
import { EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER } from '~config/editorConstants';
import { getState, modifyState } from '~src/state';
import { TextTemplate } from '@onoranzefunebricloud/giotto-text-template';
import { createEmptyPage } from '~src/multipages';
import { getTextTemplateContext } from '../../utils';
import { renderCanvasJsonTemplate } from '~core/templates';

export const templateClickHandler = async (event) => {
  event.preventDefault();
  event.stopPropagation();
  const templateId = $(event.currentTarget).data('template-id');

  // TODO: Do not remove without allowing Global Editor to reach this page
  if (getState('editorMode') === EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER) {
    router.navigate(`/template-manager/${templateId}`);
    return;
  }

  const { formatId } = calculateFormat();
  const templatesCategory = getState('selected.templatesCategory');
  const templatesCategoryId = templatesCategory.objectId;

  const project = getState('selected.tipo');
  const projectId = project.objectId;
  const template = _.get(
    window.editorLoader,
    `templates.${projectId}.${formatId}.${templatesCategoryId}.templates.items`,
    []
  ).find((t) => t.objectId === templateId);

  modifyState('selected.template', template);

  let canvasJson;

  let templatePages;

  if (template.isGlobal) {
    templatePages = template.editor_templates_default_pages;
  } else {
    templatePages = template.editor_templates_pages;
  }

  const sortedTemplatePages = _.sortBy(templatePages, ['order']);

  const sortedPages = sortedTemplatePages.map((templatePage) => ({
    order: templatePage.order,
    canvasJson: templatePage.canvasJson,
    hash: templatePage.hash,
    preview: templatePage.preview,
  }));

  const {
    servizio,
    user,
    deleganti,
    necrofori,
    card,
    serviceReservation,
  } = await getTextTemplateContext();

  const textTemplate = new TextTemplate(
    servizio,
    user,
    deleganti,
    necrofori,
    card,
    serviceReservation
  );

  const renderedPages = sortedPages.map((rawPage) => {
    const renderedPage = {
      ...rawPage,
      canvasJson: renderCanvasJsonTemplate(
        rawPage.canvasJson || JSON.stringify(createEmptyPage()),
        textTemplate
      ),
    };

    return renderedPage;
  });

  await modifyState('pages', renderedPages);

  const rawCanvasJSON = JSON.parse(
    templatePages[0].canvasJson || JSON.stringify(createEmptyPage())
  );

  if (rawCanvasJSON.canvas) {
    // old canvas
    canvasJson = JSON.stringify({
      background: '#ffffff',
      ...rawCanvasJSON.canvas,
    });
  } else {
    canvasJson = JSON.stringify(rawCanvasJSON);
  }

  modifyState('selected.template.canvas', canvasJson);

  toggleEditorHomeMenu();
  showSpinner();

  try {
    const response = await saveEditorCanvas(true);
    const { objectId } = response.data.data;
    window.editorLoader.canvasId = objectId;

    // to open the sidebar we cannot use querystring here
    // because when navigo redirects, the URL is not updated
    // in the browser and the querystring cannot be read
    // it returns null.
    // modifyState('opensidebar', 'templates');
    router.navigate(`/canvas/${objectId}`);
  } catch (error) {
    console.error(error);
    onErrorShowMessage(true);
  }
};
